import React from "react"

const FilterField = ({ label, children, grow = 1, minW = 120 }) => {
  return (
    <div style={{ flex: `${grow} 1 ${minW}px`, minWidth: minW, maxWidth: 320 }}>
      <p className="text-xs text-gray-500 font-medium mb-1.5 whitespace-nowrap">{label}</p>
      {children}
    </div>
  )
}

export default FilterField
